import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'inbox',
  children: {
    settings: {
      path: 'settings',
    },
    requests: {
      path: 'requests',
    },
    notifications: {
      path: 'notifications',
    },
    todo: {
      path: 'todo',
    },
    completed: {
      path: 'completed',
    },
  },
} as const satisfies Location
